import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useAnalytics } from 'use-analytics';
import dayjs from 'dayjs';
import DateFilter from '../../../../Filters/DateSelectorFilter';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { getTravelPolicyLeadDays } from '../../../../../store/slices/user';
import { TravelTypes, AIR_MAX_BOOKING_WINDOW_DAYS } from '../../../../../constants';

const ReturnDateFlightFilter = ({
  tripId,
  variant,
  filterButtonMaxWidth,
  label,
  flightRowIndex,
  doOpenDatePicker,
  setDoOpenDatePicker,
}) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs, defaultSearchObj } = useSelector(flightSearchInput(tripId, isTripSearch));
  const { travelAgency } = useSelector((store) => store.user);
  const leadDays = useSelector(getTravelPolicyLeadDays(TravelTypes.flight));
  const flightReturnDateLabel =
    travelAgency &&
    travelAgency.filterSettings &&
    travelAgency.filterSettings.flightReturnDateLabel;

  const handleChange = (newValue) => {
    if (newValue) {
      setDoOpenDatePicker(false);
    }
    const payload = {
      tripId,
      searchObj: {
        flightSegments: searchInputs.flightSegments ? [...searchInputs.flightSegments] : [],
        page: 1,
      },
    };

    payload.searchObj.flightSegments[flightRowIndex] = {
      ...payload.searchObj.flightSegments[flightRowIndex],
      leaveDate: newValue,
    };

    if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
    else dispatch(updateFlightSearchObj(payload));
    track('returnDateFlightFilter.handleChange', {
      returnDate: newValue,
    });
  };

  const value =
    searchInputs &&
    searchInputs.flightSegments &&
    searchInputs.flightSegments[flightRowIndex] &&
    searchInputs.flightSegments[flightRowIndex].leaveDate;

  const minDateValue =
    searchInputs &&
    searchInputs.flightSegments &&
    searchInputs.flightSegments[flightRowIndex - 1] &&
    searchInputs.flightSegments[flightRowIndex - 1].leaveDate;

  const maxDate = dayjs().add(AIR_MAX_BOOKING_WINDOW_DAYS, 'day').format('YYYY-MM-DD');

  return (
    <DateFilter
      onChange={handleChange}
      label={value ? '' : flightReturnDateLabel || label}
      value={value}
      defaultValue={isTripSearch ? value : defaultSearchObj.returnDate}
      variant={variant}
      minDate={!minDateValue ? undefined : dayjs(minDateValue).format('YYYY-MM-DD')}
      maxDate={maxDate}
      filterButtonMaxWidth={filterButtonMaxWidth}
      doOpenDatePicker={doOpenDatePicker}
      setDoOpenDatePicker={setDoOpenDatePicker}
      bgClassName={isTripSearch ? 'bg-searchInput-0' : ''}
      textColorClassName={isTripSearch ? 'text-datepicker-0' : undefined}
      leadDays={leadDays}
    />
  );
};

ReturnDateFlightFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterButtonMaxWidth: PropTypes.string,
  label: PropTypes.string,
  flightRowIndex: PropTypes.number,
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
};

ReturnDateFlightFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterButtonMaxWidth: 'max-w-full',
  label: 'Return Date',
  flightRowIndex: undefined,
  doOpenDatePicker: false,
  setDoOpenDatePicker: () => {},
};
export default memo(ReturnDateFlightFilter);
